import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import ReactDOM from "react-dom/client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/Router";
import {
  applyPendingReloadOnNavigation,
  reloadForNewBuild,
} from "@/client/utils/reloadForNewBuild";
import type { ContinuNPSConfig } from "@/client/services/hooks/useNPS";
// import { worker } from '@/client/utils/mockData/service-worker/service-worker';

declare global {
  interface Window {
    sslaConfig: any;
    sslaConfigSetup: any;
    sdht: any;
    sdad: any;
    courseDirectory: any;
    courseId: any;
    studentName: any;
    studentId: any;
    userContentId: any;
    scormPreview: any;
    contents: any;
    zESettings: any;
    newrelic: any;
    dataLayer: any;
    gtag: any;
    plantrack: any;
    Intercom: any;
    ContinuNPS?: { init: (config: ContinuNPSConfig) => void };
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

// Stale-tab recovery for Vite dynamic-import chunks.
//
// When a new build deploys, every code-split chunk gets a fresh hash
// in its filename. Tabs that loaded the SPA against the previous
// build still hold references to the OLD hashed filenames; clicking
// anything that lazy-loads a route then 404s and the route error
// boundary shows the "Oops" screen.
//
// Vite dispatches `vite:preloadError` on window for exactly this
// case. Reload to pick up the current build's chunks; the loop guard
// and storage caveats live in reloadForNewBuild.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForNewBuild()) event.preventDefault();
});

// A build-id change is not an error — the page still works — so it waits for a route change
// rather than reloading under whatever the user is doing. `vite:preloadError` above stays
// immediate: there the chunk is already missing and the route has failed to render.
applyPendingReloadOnNavigation(router);

// if (import.meta.env.MODE === 'development') {
//   worker.start({ onUnhandledRequest: 'bypass' });
// }

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <>
    {/* <React.StrictMode> */}
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
    {/* </React.StrictMode> */}
  </>
);
